/// <reference path="../include.ts" />

namespace gpx_visualizer_phase2 {

	import EventDispatcher = alm.event.EventDispatcher;

	export class ThreeManager extends EventDispatcher {

		// --------------------------------------------------
		//
		// CONSTRUCTOR
		//
		// --------------------------------------------------

		private constructor() {
			super();

			const viewportWidth:number = window.innerWidth;
			const viewportHeight:number = window.innerHeight;

			this.canvas = jQuery('#canvas3d');

			// renderer
			this.renderer = new THREE.WebGLRenderer({ canvas: this.canvas.get(0), antialias: true });
			this.renderer.setPixelRatio(window.devicePixelRatio);
			this.renderer.setSize(viewportWidth, viewportHeight);
			//this.renderer.shadowMap.enabled = true;

			// scene
			this.scene = new THREE.Scene();
			this.scene.background = new THREE.Color(0x000000);

			// lights
			{
				//this.scene.add(new THREE.AmbientLight(0x808080));

				//this.scene.add(new THREE.DirectionalLight(0xffffff, 0.3));

				this.sunMaxIntensity = 1;
				this.sun = new THREE.DirectionalLight(0xffe0cc /* 0xffcc99 */);
				this.sun.castShadow = true;
				//this.sun.shadow.mapSize.height = 2048;
				this.scene.add(this.sun);

				this.sunTarget = new THREE.Object3D();
				this.scene.add(this.sunTarget);

				this.ambientLight = new THREE.AmbientLight(0xffffff, 0.35);
				this.scene.add(this.ambientLight);

				//this.sunDebug = new THREE.DirectionalLightHelper(this.sun, 100);
				//this.scene.add(this.sunDebug);
			}

			// debugger
			//this.scene.add(new THREE['AxesHelper'](100));

			// camera
			this.cameraManager = new CameraManager();
			this.cameraManager.setup(viewportWidth, viewportHeight, this.scene, this.canvas.get(0));
			this.cameraManager.addEventListener(CameraTrackingEvent.CHANGE, this.cameraManagerCameraTrackingHandler);

			// tracking
			this.trackingTarget = null;
		}





		// --------------------------------------------------
		//
		// METHOD
		//
		// --------------------------------------------------

		public setMap(map:Map):void {
			this.cameraManager.setMap(map);
		}

		public update(useTransition:boolean = true):void {
			this.cameraManager.update(useTransition);
			this.renderer.render(this.scene, this.cameraManager.getCamera());
		}

		public setLookAtTarget(position:THREE.Vector3):void {
			this.cameraManager.setLookAt(position);
		}

		public setSun(horizontalAngle:number, verticalAngle:number, intensity:number):void {
			const dem = AssetLoader.getInstance().getDem();
			const meta = AssetLoader.getInstance().getMeta();
			const mapBounds = meta.getBounds();

			const radius = Math.max(mapBounds.getPixelWidth(), mapBounds.getPixelHeight());
			const spherical = new THREE.Spherical(radius, verticalAngle, horizontalAngle);
			spherical.makeSafe();

			const mapCenter = Unit.pixelElevationToSpace(mapBounds.getCenter().getPixel(), dem.getMinElevation(), meta.getZoomLevel());

			this.sun.position.setFromSpherical(spherical);
			this.sun.position.add(mapCenter);

			this.sunTarget.position.copy(mapCenter);
			this.sun.target = this.sunTarget;
			this.sun.intensity = intensity * this.sunMaxIntensity;

			if (this.sunDebug) {
				this.sunDebug.update();
			}
		}

		public project(point:THREE.Vector3, result:THREE.Vector3 = null):void {
			this.cameraManager.project(point, result);
		}

		public getScene():THREE.Scene {
			return this.scene;
		}

		public getCameraPosition():THREE.Vector3 {
			return this.cameraManager.getCamera().position;
		}

		public reset(center:THREE.Vector3):void {
			this.cameraManager.reset(center);
		}

		public setInteraction(isEnabled:boolean):void {
			this.cameraManager.setInteraction(isEnabled);
		}

		public resize():void {
			const viewportWidth:number = window.innerWidth;
			const viewportHeight:number = window.innerHeight;

			this.cameraManager.resize(viewportWidth, viewportHeight);
			this.renderer.setSize(viewportWidth, viewportHeight);
		}

		public startTracking(target:THREE.Object3D):void {
			this.trackingTarget = target;
			this.cameraManager.toggleTracking(true);
		}

		public stopTracking():void {
			this.trackingTarget = null;
			this.cameraManager.toggleTracking(false);
		}

		public startOpening():void {
			this.cameraManager.startOpening();
		}

		public startEnding(orbitPosition:THREE.Vector3):void {
			this.cameraManager.startEnding(orbitPosition);
		}

		public getIsTracking():boolean {
			return this.cameraManager.getIsTracking();
		}

		public getIsEnding():boolean {
			return this.cameraManager.getIsEnding();
		}

		private cameraManagerCameraTrackingHandler = (event:CameraTrackingEvent):void => {
			this.dispatchEvent(new CameraTrackingEvent(CameraTrackingEvent.CHANGE, this, event.getIsTracking()));
		};





		// --------------------------------------------------
		//
		// VARIABLE
		//
		// --------------------------------------------------

		public static getInstance():ThreeManager { return this.instance || (this.instance = new ThreeManager()) };
		private static instance:ThreeManager = null;

		private canvas:JQuery<HTMLCanvasElement>;
		private scene:THREE.Scene;
		private renderer:THREE.WebGLRenderer;

		private sun:THREE.DirectionalLight;
		private sunTarget:THREE.Object3D;
		private sunDebug:THREE.DirectionalLightHelper;
		private sunMaxIntensity:number;

		private ambientLight:THREE.AmbientLight;

		private trackingTarget:THREE.Object3D;
		private cameraManager:CameraManager;
	}
}
